import { Container } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "./CSS/Projects.css";
import allProjects from '../assets/Routes/AllProject';

function Projects() {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Projects | Lee</title>
        </Helmet>
      </HelmetProvider>
      <Container fluid className="projects-container">
        <div className="projects-title animate__animated animate__zoomIn">
          <h3>Featured Projects</h3>
          <h4>
            ───&nbsp;&nbsp;Page <strong>04</strong>
          </h4>
          <p>
            The selected systems focused on operational clarity, maintainable service boundaries, and structured workflows.
          </p>
        </div>
        <div className="projects-wrapper animate__animated animate__fadeIn animate_slower my-4">
          <div className="projects-grid custom-margin-bottom">
            {allProjects.map((project) => (
              <article className="project-card" key={project.title}>
                  <div className="imgsec">
                    <img src={project.img} alt={project.title} loading="lazy" />
                  </div>
                  <div className="project-content">
                    <div className="project-summary">
                      <h3>{project.title}</h3>
                      <p>{project.description}</p>
                      {project.focus && (
                        <p className="project-focus">
                          <span>Focus:</span> {project.focus.join(" · ")}
                        </p>
                      )}
                    </div>
                    <div className="project-meta">
                      <p className="tech-stack-line">{project.techStack.join(" • ")}</p>
                      {project.githubUrl && (
                        <a className="btn-github" href={project.githubUrl} target="_blank" rel="noreferrer">
                          <AiFillGithub className="project-icon" />
                          GitHub
                        </a>
                      )}
                    </div>
                  </div>
              </article>
            ))}
          </div>
        </div>
      </Container>
    </>
  );
}

export default Projects;
